import { TTimezone } from '../types/index'

export const TIMEZONE = {
  CANCUN: 'America/Cancun',
  CHIHUAHUA: 'America/Chihuahua',
  CIUDAD_JUAREZ: 'America/Ciudad_Juarez',
  ENSENADA: 'America/Ensenada',
  HERMOSILLO: 'America/Hermosillo',
  LA_PAZ: 'America/La_Paz',
  MATAMOROS: 'America/Matamoros',
  MAZATLAN: 'America/Mazatlan',
  MERIDA: 'America/Merida',
  MEXICO_CITY: 'America/Mexico_City',
  MONTERREY: 'America/Monterrey',
  TIJUANA: 'America/Tijuana'
}

export const US_TIMEZONE = {
  ANCHORAGE: 'America/Anchorage',
  ADAK: 'America/Adak',
  PHOENIX: 'America/Phoenix',
  CHICAGO: 'America/Chicago',
  INDIANAPOLIS: 'America/Indiana/Indianapolis',
  NEW_YORK: 'America/New_York',
  HONOLULU: 'Pacific/Honolulu',
  KNOX: 'America/Indiana/Knox',
  DETROIT: 'America/Detroit',
  DENVER: 'America/Denver',
  LOS_ANGELES: 'America/Los_Angeles'
}

export const TIMEZONES: TTimezone[] = [
  { value: TIMEZONE.CANCUN, label: 'America/Cancun' },
  { value: TIMEZONE.CHIHUAHUA, label: 'America/Chihuahua' },
  { value: TIMEZONE.CIUDAD_JUAREZ, label: 'America/Ciudad_Juarez' },
  { value: TIMEZONE.ENSENADA, label: 'America/Ensenada' },
  { value: TIMEZONE.HERMOSILLO, label: 'America/Hermosillo' },
  { value: TIMEZONE.LA_PAZ, label: 'America/La_Paz' },
  { value: TIMEZONE.MATAMOROS, label: 'America/Matamoros' },
  { value: TIMEZONE.MAZATLAN, label: 'America/Mazatlan' },
  { value: TIMEZONE.MERIDA, label: 'America/Merida' },
  { value: TIMEZONE.MEXICO_CITY, label: 'America/Mexico_City' },
  { value: TIMEZONE.MONTERREY, label: 'America/Monterrey' },
  { value: TIMEZONE.TIJUANA, label: 'America/Tijuana' }
]

export const US_TIMEZONES: TTimezone[] = [
  { value: US_TIMEZONE.ANCHORAGE, label: 'America/Anchorage' },
  { value: US_TIMEZONE.ADAK, label: 'America/Adak' },
  { value: US_TIMEZONE.PHOENIX, label: 'America/Phoenix' },
  { value: US_TIMEZONE.CHICAGO, label: 'America/Chicago' },
  { value: US_TIMEZONE.INDIANAPOLIS, label: 'America/Indiana/Indianapolis' },
  { value: US_TIMEZONE.NEW_YORK, label: 'America/New_York' },
  { value: US_TIMEZONE.HONOLULU, label: 'Pacific/Honolulu' },
  { value: US_TIMEZONE.KNOX, label: 'America/Indiana/Knox' },
  { value: US_TIMEZONE.DETROIT, label: 'America/Detroit' },
  { value: US_TIMEZONE.DENVER, label: 'America/Denver' },
  { value: US_TIMEZONE.LOS_ANGELES, label: 'America/Los_Angeles' }
]
